
export default function RequestInterceptor(cfg, userDetails) {
    const ccUrlRegex = new RegExp(window.CONFIG['costcutter.url.regexMatcher']);
    if (!ccUrlRegex.test(cfg.url)) {
        return cfg;
    }

    const currentHeaders = Object.keys(cfg.headers).map(key => key.toLowerCase());
    if (currentHeaders.includes('x-franchise-code')) {
        return cfg;
    }

    if(!userDetails?.currentFranchise?.code) {
        return cfg;
    }

    const franchiseCodeExceptions = window.CONFIG['costcutter.url.request.headers.franchiseCodeExceptions'];
    const servicesToIgnore = franchiseCodeExceptions.split(',').map(service => service.toLowerCase());
    if(!!servicesToIgnore.find(serviceName => cfg.url.toLowerCase().includes(serviceName))) {
        return cfg;
    }

    return { ...cfg, headers: { ...cfg.headers, 'X-Franchise-Code': userDetails.currentFranchise.code} };
}